import { render, staticRenderFns } from "./orderMap.vue?vue&type=template&id=20e872d7&scoped=true"
import script from "./orderMap.vue?vue&type=script&lang=js"
export * from "./orderMap.vue?vue&type=script&lang=js"
import style0 from "./orderMap.vue?vue&type=style&index=0&id=20e872d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e872d7",
  null
  
)

export default component.exports